export default function(mediaPlayer, koAllCues) {
  var _self = this;
  _self._media_player = {};
  _self._media_player = mediaPlayer;
  _self._koAllCues = koAllCues; //to simplify updates
  _self._koQuestionCues = [];
  _self._subscriptions = [];
  _self._$questionMarkers = [];
  _self._$nextQuestionCtrl;
  _self._$prevQuestionCtrl;

  var seekToNextQuestion = function() {
    var curTime = Math.round10(_self._media_player.currentTime(), -3);
    var nextQ = null;

    for(var i = 0; i < _self._koQuestionCues.length; i++) {
      if(Math.round10(_self._koQuestionCues[i].cue_start_time(), -3) > curTime) {
        nextQ = _self._koQuestionCues[i];
        break;
      }
    }

    if(nextQ) {
      _self._media_player.currentTime(nextQ.cue_start_time());
    }
    //else ignore, already past last question
  };

  var seekToPreviousQuestion = function() {
    var curTime = Math.round10(_self._media_player.currentTime(), -3);
    var prevQ = null;

    for(var i = _self._koQuestionCues.length - 1; i >= 0; i--) {
      if(Math.round10(_self._koQuestionCues[i].cue_start_time(), -3) < curTime) {
        prevQ = _self._koQuestionCues[i];
        break;
      }
    }

    if(prevQ) {
      _self._media_player.currentTime(prevQ.cue_start_time());
    }
    //else ignore, already before first cue
  };

  var insertQuestionMarkers = function() {
    var $questionMarker = $('<div class=\'kdze-question-marker\'></div>');
    _.each(_self._koQuestionCues, function(question, ix) {
      //insert markers just before seek handle, to maintain appropriate z-ordering:
      var $qmClone = $questionMarker.clone();
      $qmClone.attr('title', question.cued.name());
      _self._media_player.seekBar$El().find('.vjs-play-progress').before($qmClone);
      _self._$questionMarkers.push($qmClone);

      var markerPosPercent = parseFloat(question.cue_start_time()) / Math.round10(_self._media_player.duration(), -3) * 100.0;
      $qmClone.css('left', markerPosPercent.toString() + '%');

      $qmClone.on('mousedown', function(evt) {
        _self._media_player.currentTime(question.cue_start_time());
        evt.stopPropagation();
      });
    });
  };

  var removeQuestionMarkers = function() {
    _.each(_self._$questionMarkers, function($marker, ix) {
      $marker.remove();
    });

    _self._$questionMarkers = [];
  };

  var subscribe = function() {
    //subscribe to array updates
    _self._subscriptions.push(_self._koAllCues.subscribe(updateQuestions, null, 'arrayChange'));

    //subscribe to cue content updates as well
    _.each(_self._koQuestionCues, function(koCue, ix) {
      _self._subscriptions.push(koCue.cue_start_time.subscribe(updateQuestions));
      _self._subscriptions.push(koCue.cue_end_time.subscribe(updateQuestions));
    });
  };

  var unsubscribe = function() {
    _.each(_self._subscriptions, function(sub, ix) {
      sub.dispose();
    });
    _self._subscriptions = [];
  };

  var insertQuestionMarkers = function()
  {
    var $questionMarker = $('<div class=\'kdze-question-marker\'></div>');
    _.each(_self._koQuestionCues, function(question, ix)
    {
      //insert markers just before seek handle, to maintain appropriate z-ordering:
      var $qmClone = $questionMarker.clone();
      $qmClone.attr('title', question.cued.name());
      _self._media_player.seekBar$El().find('.vjs-seek-handle').before($qmClone);
      _self._$questionMarkers.push($qmClone);

      var markerPosPercent = parseFloat(question.cue_start_time()) / Math.round10(_self._media_player.duration(), -3) * 100.0;
      $qmClone.css('left', markerPosPercent.toString() + '%');

      $qmClone.on('mousedown', function(evt)
      {
        _self._media_player.currentTime(question.cue_start_time());
        evt.stopPropagation();
      });
    });
  };

  var removeQuestionMarkers = function()
  {
    _.each(_self._$questionMarkers, function($marker, ix)
    {
      $marker.remove();
    });
  };

  var updateQuestions = function(newVals) {
    unsubscribe();
    _self._koQuestionCues = [];

    _.each(_self._koAllCues(), function(koCue, ix) {
      if(koCue.type() === 'MediaQuestion' && !koCue._destroy)
        _self._koQuestionCues.push(koCue);
    });

    //sort
    _self._koQuestionCues.sort(function(a, b) {
      if(parseFloat(a.cue_start_time()) < parseFloat(b.cue_start_time()))
        return -1;
      if(parseFloat(a.cue_start_time()) > parseFloat(b.cue_start_time()))
        return 1;
      return 0;
    });

    removeQuestionMarkers();
    insertQuestionMarkers();
    subscribe();
  };

  _self.present = function() {
    !_self._media_player.shown() && _self._media_player.show(); //need a player to decorate

    _self._media_player.addEventListener('skipForwardToQuestion', function() {
      seekToNextQuestion();
    });

    _self._media_player.addEventListener('skipBackToQuestion', function() {
      seekToPreviousQuestion();
    });

    //insert markers only when we have a solid video duration (after media is loaded):
    (function poll() {
      //make sure the media is loaded
      if(_self._media_player.duration() == 0) {
        setTimeout(poll, 100);
      }
      else //get on with it
      {
        insertQuestionMarkers();
      }
    })();
  };

  //constructor
  //extract question cues:
  var ac = koAllCues();
  _.each(ac, function(koCue, ix) {
    if(koCue.type && koCue.type() === 'MediaQuestion') {
      _self._koQuestionCues.push(koCue);
    }
  });

  //subscribe to updates
  subscribe();
}

